export default function UniqueValues(value, index, array) {
    return array.indexOf(value) === index;
  }